module.exports = __webpack_public_path__ + "static/media/zilwaukeBridge.d823daa8.jpg";